module.exports = ".ck.ck-editor__editable img.image_placeholder{background-size:100% 100%}"